import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BrandTaxonomyDialogComponent } from './brand-taxonomy-dialog.component';
import { VaFormsModule } from '@vendasta/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [CommonModule, VaFormsModule, MatDialogModule, MatButtonModule, ReactiveFormsModule, TranslateModule],
  exports: [BrandTaxonomyDialogComponent],
  declarations: [BrandTaxonomyDialogComponent],
})
export class BrandTaxonomyDialogModule {}
